import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import { endImpersonation, isImpersonating } from '../../../utils/impersonationSession';
import { useAuth } from '../../../context/AuthContext/AuthContext';

const AdminViewBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { profile, user } = useAuth();

  /**
   * Closes the client tab; the admin session was never replaced, so the admin tab is still there.
   */
  const handleBackToAdminView = () => {
    endImpersonation(user?.userId);
  };

  if (!isImpersonating()) {
    return null;
  }

  const userName = profile
    ? `${profile.firstname || ''} ${profile.lastname || ''}`.trim() || profile.email
    : t('adminViewBanner');

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#1976d2',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 24px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {t('adminViewBanner')} <strong>{userName}</strong>
      </Typography>
      <Button
        variant="outlined"
        size="small"
        onClick={handleBackToAdminView}
        sx={{
          textTransform: 'none',
          borderColor: 'white',
          color: 'white',
          '&:hover': {
            borderColor: 'white',
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        {t('backToAdmin')}
      </Button>
    </Box>
  );
};

export default AdminViewBanner;
